import { jobs, states } from "../../configs";
import localforage from "localforage";

export const appId = "bqzjj6ed4";

const initialTableConfigs = {
  jobs,
  employees: {
    tableId: "bunsrujr4",
    fetchFilter: "{46.EX.'Active'}",
    fields: [
      { id: -1, label: "childrenUpdated", type: "boolean" },
      { id: 0, label: "locallyUpdatedAt", type: "number" },
      { id: 1, label: "dateCreated", type: "string" },
      { id: 2, label: "dateModified", type: "string" },
      { id: 3, label: "recordId", type: "key", inputType: "number" },
      { id: 4, label: "recordOwner", type: "object" },
      { id: 5, label: "lastModifiedBy", type: "object" },
      { id: 43, label: "name", type: "string" },
      { id: 50, label: "titles", type: "string" },
      { id: 51, label: "payType", type: "string" },
    ],
  },
  equipment: {
    tableId: "bunsrujr5",
    fields: [
      { id: -1, label: "childrenUpdated", type: "boolean" },
      { id: 0, label: "locallyUpdatedAt", type: "number" },
      { id: 1, label: "dateCreated", type: "string" },
      { id: 2, label: "dateModified", type: "string" },
      { id: 3, label: "recordId", type: "key", inputType: "number" },
      { id: 4, label: "recordOwner", type: "object" },
      { id: 5, label: "lastModifiedBy", type: "object" },
      { id: 7, label: "equipmentName", type: "string" },
      { id: 22, label: "unitOfMeasure", type: "string" },
      { id: 25, label: "highlightAmount", type: "number" },
      { id: 26, label: "standardItem", type: "boolean" },
    ],
  },
  laborLineItems: {
    tableId: "bva84kwwz",
    //fetchFilter: "{102.EX.'1'}",
    fields: [
      {
        id: 83,
        label: "tempId",
        sendAs: String,
        convertTo: Number,
        type: "number",
        editable: true,
      },
      { id: -1, label: "childrenUpdated", type: "boolean" },
      { id: 0, label: "locallyUpdatedAt", type: "number" },
      { id: 1, label: "dateCreated", type: "string" },
      { id: 2, label: "dateModified", type: "string" },
      { id: 3, label: "recordId", type: "key", inputType: "number" },
      { id: 4, label: "recordOwner", type: "object" },
      {
        id: 104,
        label: "relatedDailyFieldReport",
        type: "number",
        inputType: "number",
        editable: true,
        relTo: "dailyFieldReports",
      },
      {
        id: 20,
        label: "startTime",
        type: "string",
        editable: true,
        inputType: "time",
      },
      {
        id: 21,
        label: "endTime",
        type: "string",
        editable: true,
        inputType: "time",
      },
      {
        id: 22,
        label: "driver",
        type: "boolean",
        editable: true,
        inputType: "checkbox",
      },
      {
        id: 23,
        label: "position",
        type: "string",
        editable: true,
        inputType: "text",
      },
      {
        id: 37,
        label: "relatedEmployee",
        type: "number",
        editable: true,
        relTo: "employees",
        inputType: "relationship",
        filterFunction: (employee) => true,
      },
      {
        id: 107,
        label: "earnCode",
        type: "string",
        editable: true,
        inputType: "text-multichoice",
        options: [
          "Regular",
          "Overtime",
          "Double Time",
        ],
      },
      {
        id: 106,
        label: "hours",
        type: "number",
        editable: true,
        inputType: "number",
      },
      {
        id: 108,
        label: "shift",
        editable: true,
        options: ["First", "Second", "Third"],
        type: "string",
        inputType: "text-multichoice",
      },
    ],
  },
  equipmentLineItems: {
    tableId: "bva84mmv7",
    //    fetchFilter: "{34.EX.'1'}",
    fields: [
      {
        id: 19,
        label: "tempId",
        sendAs: String,
        convertTo: Number,
        type: "number",
        editable: true,
      },
      { id: -1, label: "childrenUpdated", type: "boolean" },
      { id: 0, label: "locallyUpdatedAt", type: "number" },
      { id: 1, label: "dateCreated", type: "string" },
      { id: 2, label: "dateModified", type: "string" },
      { id: 3, label: "recordId", type: "key", inputType: "number" },
      { id: 4, label: "recordOwner", type: "object" },
      { id: 5, label: "lastModifiedBy", type: "object" },
      {
        id: 35,
        label: "relatedDailyFieldReport",
        type: "number",
        editable: true,
        relTo: "dailyFieldReports",
      },
      {
        id: 38,
        label: "name",
        type: "string",
        editable: true,
        inputType: "text",
      },
      {
        id: 15,
        label: "type",
        type: "string",
        editable: true,
        inputType: "text-multichoice",
        options: [
          "Van Stock",
          "PO",
          "Divvy",
          "Logistics",
          "Equipment",
          "Other",
        ],
      },
      {
        id: 39,
        label: "note",
        type: "string",
        editable: true,
        inputType: "text",
      },
      {
        id: 14,
        label: "quantity",
        type: "number",
        inputType: "number",
        editable: true,
      },
    ],
  },
  dailyFieldReports: {
    tableId: "bva84eckk",
    fetchFilter: "{107.EX.'1'}",
    fields: [
      {
        id: 84,
        label: "tempId",
        sendAs: String,
        convertTo: Number,
        type: "number",
        editable: true,
      },
      { id: -2, label: "submitted", type: "boolean" },
      { id: -1, label: "childrenUpdated", type: "boolean" },
      { id: 0, label: "locallyUpdatedAt", type: "number" },
      { id: 1, label: "dateCreated", type: "string" },
      { id: 2, label: "dateModified", type: "string" },
      { id: 3, label: "recordId", type: "key", inputType: "number" },
      { id: 4, label: "recordOwner", type: "object" },
      { id: 5, label: "lastModifiedBy", type: "object" },
      { id: 7, label: "street1", type: "string", editable: true },
      { id: 8, label: "street2", type: "string", editable: true },
      { id: 9, label: "city", type: "string", editable: true },
      {
        id: 10,
        label: "state",
        type: "string",
        editable: true,
        options: states,
      },
      { id: 11, label: "postalCode", type: "string", editable: true },
      { id: 12, label: "country", type: "string", editable: true },
      {
        id: 13,
        label: "date",
        sendAs: (string) => string + "T00:00:00",
        convertTo: (string) => {
          if (!string) return string;
          const date = new Date(string);
          return `${date.getFullYear()}-${date.getMonth() + 1
            }-${date.getDate()}`;
        },
        stringtype: "string",
        editable: true,
        inputType: "text",
      },
      {
        id: 14,
        label: "workOrderNumber",
        type: "string",
        editable: true,
        inputType: "text",
      },
      { id: 15, label: "foremanName", type: "string", editable: true },
      { id: 16, label: "foremanSignature", type: "object", editable: true },
      { id: 17, label: "inspectorName", type: "string", editable: true },
      { id: 18, label: "inspectorSignature", type: "object", editable: true },
      {
        id: 109,
        label: "jobNumber",
        type: "string",
        editable: true,
        relTo: "jobs",
        inputType: "text",
      },
      { id: 32, label: "status", type: "string", editable: true },
      {
        id: 79,
        label: "notes",
        type: "string",
        editable: true,
        inputType: "text",
      },
      {
        id: 114,
        label: "followUp",
        type: "string",
        inputType: "text",
        editable: true,
      },
      {
        id: 115,
        label: "pdf",
        type: "file",
        inputType: "file",
        editable: true,
      },
      { id: 124, label: "ticketNumStamp", type: "number", editable: true },
    ],
  },
  // Add more tables here in the same structure
};

/**
 * Deeply clones an object or array, preserving function references.
 * This avoids the error from structuredClone when functions are present.
 * @param {any} item The item to clone.
 * @returns {any} A deep copy of the item.
 */
function deepCloneWithFunctions(item) {
  if (!item) return item;

  let new_item = Array.isArray(item) ? [] : {};

  for (let i in item) {
    let value = item[i];
    if (typeof value === "object" && value !== null) {
      new_item[i] = deepCloneWithFunctions(value);
    } else {
      new_item[i] = value;
    }
  }

  return new_item;
}

/**
 * Builds the full configuration object from the initial configs.
 * @param {object} configs - The initial table configurations.
 * @returns {object} The fully processed configuration object.
 */
function buildOutConfigs(configs) {
  const newConfigs = deepCloneWithFunctions(configs);

  Object.values(newConfigs).forEach((table) => {
    table.childTables = {};
    table.minTempId = 0;
    table.tableLastSynced = 100;
  });

  for (const [tableName, config] of Object.entries(newConfigs)) {
    for (const field of config.fields) {
      if (field.relTo && newConfigs[field.relTo]) {
        newConfigs[field.relTo].childTables[tableName] = field;
      }
    }
  }
  return newConfigs;
}

export const tableConfigs = buildOutConfigs(initialTableConfigs);

export const getLowestTempId = async (tableName, db) => {
  const { fields } = tableConfigs[tableName];
  const keyField = fields.find((field) => field.type === "key").label;
  const lowestRecord = await db[tableName].orderBy(keyField).first();
  // Return the record's key value if it's negative, otherwise default to 0.
  return lowestRecord && lowestRecord[keyField] < 0
    ? lowestRecord[keyField]
    : 0;
};

/**
 * Helper function to remove function properties from a config object
 * before it's stored, as functions can't be serialized in JSON.
 * @param {object} config - The table config object.
 * @returns {object} A sanitized config object suitable for storage.
 */
const sanitizeConfigForStorage = (config) => {
  const newConfig = { ...config };
  newConfig.fields = newConfig.fields.map((field) => {
    const { filterFunction, formulaFunction, sendAs, convertTo, ...rest } =
      field;
    return rest;
  });
  delete newConfig.childTables; // This is generated dynamically.
  return newConfig;
};

/**
 * Initializes and synchronizes table configurations with localforage.
 * This version:
 * - Uses only localforage for asynchronous, non-blocking storage.
 * - Fixes the async loop by using a `for...of` loop instead of `forEach`.
 * - Simplifies logic for handling new vs. existing tables.
 *
 * @param {object} db - The Dexie database instance.
 */
export async function initForage(db) {
  const tableNames = Object.keys(tableConfigs);
  const forageTablesKey = `${appId}_tables`;
  const metadataKey = `${appId}_metadata`;

  // 1. Get existing stored data from localforage.
  let storedTables = await localforage.getItem(forageTablesKey) || {};
  let metadata = await localforage.getItem(metadataKey);

  // 2. Initialize metadata if it doesn't exist.
  if (!metadata) {
    await localforage.setItem(metadataKey, { lastSyncCheck: 100 });
  }

  // 3. Build the final table configs to be stored.
  const finalTablesToStore = {};

  // Use a for...of loop to handle await correctly.
  for (const tableName of tableNames) {
    const staticConfig = tableConfigs[tableName];
    const storedConfig = storedTables[tableName] || {};

    // Determine the lowest temp ID by checking the stored value and the current DB state.
    const lowestIdInDexie = await getLowestTempId(tableName, db);
    const minTempId = Math.min(storedConfig.minTempId || 0, lowestIdInDexie);

    // Merge static config with dynamic/stored values.
    finalTablesToStore[tableName] = {
      ...sanitizeConfigForStorage(staticConfig),
      minTempId,
      tableLastSynced: storedConfig.tableLastSynced ||
        staticConfig.tableLastSynced,
    };
  }

  // 4. Save the updated configs back to localforage.
  await localforage.setItem(forageTablesKey, finalTablesToStore);
}
